import Component from 'core/Component';
import { deepMerge } from 'toolbox/deepMerge';
import comparisonStore from 'stores/ComparisonStore';

/**
 * This is a description of the AbstractComparison constructor function.
 * @class
 * @classdesc This is a description of the AbstractComparison class. (must be edited)
 * @extends Component
 */
export default class AbstractComparison extends Component {
    /**
     * Constructor of the class that mainly merge the options of the components
     * @param {HTMLElement} element HTMLElement of the component
     * @param {object} options options that belongs to the component
     */
    constructor(element, options = {}) {
        super(element, deepMerge({
            selectedProducts: [],
            initStorageData: false, // if true, init storage with selected products
            instanceId: null, // comparison id, to differentiate multiple comparison tables present
            // on the page, if not passed can be taken from closest DOM element, "default" by default
        }, options), comparisonStore);
    }

    /**
     * Init the different state of the component
     * It helps to avoid heavy DOM manipulation
     */
    initState() {
        let { instanceId } = this.options;
        if (!instanceId) {
            const comparisonIdElement = this.element.closest('[data-comparison-id]');
            if (comparisonIdElement) {
                instanceId = comparisonIdElement.getAttribute('data-comparison-id');
            }
        }

        this.state.instanceId = instanceId || 'default';
    }

    /**
     * After init
     * Set Initial data for the store
     */
    afterInit() {
        if (this.options.initStorageData) {
            comparisonStore.dispatch('init', {
                products: this.options.selectedProducts.map(pid => ({ pid })),
                instanceId: this.state.instanceId,
            });
        } else {
            this.syncProducts(comparisonStore.get());
        }
    }

    /**
     * StoreUpdated Hook
     * @param {Object} state new state
     */
    storeUpdated(state) {
        this.syncProducts(state);
    }

    /**
    * Replace product from previous to the new pid in the list of selected products
    * @param {String} previousPid previous product id
    * @param {String} pid new product id
    */
    replaceProduct(previousPid, pid) {
        comparisonStore.dispatch('replaceProduct', {
            previousPid,
            pid,
            instanceId: this.state.instanceId,
        });
    }

    /**
    * Remove product from list of selected products
    * @param {String} pid selected product id
    */
    removeProduct(pid) {
        comparisonStore.dispatch('removeProduct', {
            pid,
            instanceId: this.state.instanceId,
        });
    }

    /**
     * Synchronize products with store
     * @param {Object} state new state
     */
    syncProducts(state) {
        // check if selected products were changed
        const currentState = state[this.state.instanceId];
        if (currentState && !this.isSelectedProductsEqual(currentState.products)) {
            this.reload(this.getReloadData(currentState.products));
        }
    }

    /**
     * Returns object with product ids
     * @param {Array} products array of selected pids
     * @returns {Object} object with selected pid
     */
    getReloadData(products) {
        const params = {
            comparisonId: this.state.instanceId,
        };

        Object.keys(products).forEach((index) => {
            params[`pid_${index}`] = products[index] && products[index].pid;
        });

        return params;
    }

    /**
     * Compare products from store with current state of component
     * @param {Array} products array of products
     * @returns {Boolean} true if products are same
     */
    isSelectedProductsEqual(products) {
        if (this.options.selectedProducts.length !== products.length) {
            return false;
        }

        return !products.some(item => !this.options.selectedProducts.includes(item.pid));
    }
}
